/* Header entry points for app widgets: wishlist heart -> Growave drawer; "Chat with us" (top bar, phone menu and the header icon) -> our shopper chat when its script has run (BG-199), otherwise the Gorgias window.
   Each opens the app when it is ready within 4s; otherwise (not loaded, never ready, error) it follows the link's own href. */
(function () {
  'use strict';

  var html = document.documentElement;
  var pending = false; // one open attempt at a time, until it settles
  var chatWired = false;

  // Runs start(done) once; whichever of done/failure/timeout comes first wins, and later callbacks are ignored.
  function attempt(href, start) {
    pending = true;
    var settled = false;
    function settle(ok) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      pending = false;
      if (!ok) location.href = href;
    }
    var timer = setTimeout(function () { settle(false); }, 4000);
    try {
      start(function () { settle(true); }, function () { settle(false); }, function () { return !settled; });
    } catch (e) {
      settle(false);
    }
  }

  function openWishlist(event, href) {
    var gw = window.gw;
    if (!gw || !gw.sdk) return; // SDK not on the page: the link navigates
    event.preventDefault();
    if (pending) return;
    attempt(href, function (ok, fail, live) {
      gw.sdk.runIfModuleReady(gw.sdk.common.constants.modules.WISHLISTS, function () {
        if (!live()) return; // already fell back to the link
        gw.sdk.wishlists.methods.openWishlistsDrawer().then(ok, fail);
      });
    });
  }

  // Closes the phone menu drawer synchronously via the theme's own method. toToggle: hand focus to the menu button (null opener = no handback).
  function closePhoneMenu(toToggle) {
    var menu = document.querySelector('main-menu');
    if (menu && menu.mainContent && menu.mainContent.classList.contains('is-open')) {
      menu.opener = toToggle ? menu.mainToggle : null;
      menu.closeMainMenu(false);
    }
  }

  // BG-199: our shopper chat, once its script has run. open() is synchronous, so no attempt()/timeout.
  // The chat gives focus back to what had it when open() ran (widget-v2.js setOpen). From the phone menu that is the
  // menu button (the menu closes); from the header icon or the top bar it is the link, focused here because a tap
  // does not focus a link in Safari (BG-199 T7).
  function openShopChat(event, link) {
    var chat = window.BGBChat;
    if (!chat || typeof chat.open !== 'function') return false; // setting off, slow or blocked: Gorgias, then the link
    event.preventDefault();
    var inMenu = !!link.closest('.main-menu__content');
    closePhoneMenu(inMenu);
    if (!inMenu) link.focus({ preventScroll: true });
    try { chat.open(); } catch (e) { location.href = '/pages/contact-us'; }
    return true;
  }

  // The chat window is hidden by theme CSS until opened from the link; its Close button hides it again.
  function openChat(event, href) {
    if (!window.GorgiasChat) return; // chat script not on the page: the link navigates
    event.preventDefault();
    if (pending) return;
    attempt(href, function (ok, fail, live) {
      window.GorgiasChat.init().then(function () {
        if (!live()) return; // already fell back to the link
        // Close the phone menu drawer first, synchronously via the theme's own method, so its focus trap does not sit over the chat.
        // opener = null stops it handing focus back to the hamburger.
        closePhoneMenu(false);
        html.classList.add('gorgias-chat-shown');
        window.GorgiasChat.open();
        if (!chatWired) {
          chatWired = true;
          window.GorgiasChat.on('widget:closed', function () { html.classList.remove('gorgias-chat-shown'); });
        }
        ok();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest || event.defaultPrevented || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var link = t.closest('[data-gw-wishlist], a[href$="#gorgias-chat"]');
    if (!link) return;
    if (link.hasAttribute('data-gw-wishlist')) openWishlist(event, link.href);
    else if (!openShopChat(event, link)) openChat(event, '/pages/contact-us');
  });
})();
